// extracted by mini-css-extract-plugin
export default {"notesArea":"NoteAreaComponent_notesArea__4wWzS"};